module.exports = __webpack_public_path__ + "img/shujufuwu.d96ad703.png";